var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyquoteIcon = function SvgEmptyquoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 163,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6B3BA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M30.499 40.663v28.9c0 21.513 0 32.274 6.62 38.955 6.613 6.681 17.258 6.681 38.556 6.681H86.97c21.291 0 31.936 0 38.556-6.681 6.613-6.688 6.613-17.442 6.613-38.955v-28.9m-101.64 0h101.64m-101.64 0 4.885-10.422c3.795-8.09 5.692-12.129 9.527-14.406 3.842-2.276 8.762-2.276 18.62-2.276h35.575c9.852 0 14.779 0 18.621 2.276 3.842 2.277 5.739 6.316 9.527 14.406l4.885 10.422M71.155 60.99h20.328M81.32 132.139v16.94m0-16.94h-33.88m33.88 0h33.88m-67.76 0h-16.94a16.94 16.94 0 0 0-16.94 16.94m33.88-16.94v16.94m67.76-16.94h16.94a16.94 16.94 0 0 1 16.94 16.94m-33.88-16.94v16.94"
  })));
};
export default SvgEmptyquoteIcon;